var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenWriteForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 27.5876V41C18 42.1046 18.8954 43 20 43H44C45.1046 43 46 42.1046 46 41V27.5882L32.0007 33.588L18 27.5876Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25.4356L18.3689 25.5698L32.0007 31.412L45.5225 25.617L46 25.2986V23C46 21.8954 45.1046 21 44 21H20C18.8954 21 18 21.8954 18 23V25.4356Z",
    fill: "#fff"
  })));
}

export default SvgOpenWriteForm;